// extracted by mini-css-extract-plugin
module.exports =  {"container":"_9330de7794--container--wvk02","info":"_9330de7794--info--f772x","link":"_9330de7794--link--iQUIM"};